import { convertJobShiftToTitleCase } from "utils/Utils";

const ShowStatus = ({ status }) => {

  switch (status) {
    case "APPLIED":
      return ( <div className="nex-pill applied">Applied</div> ); 

    case "SHORTLISTED":
      return ( <div className="nex-pill shortlisted">Shortlisted</div> ); 

    case "INTERVIEW":
      return ( <div className="nex-pill offered">Interview</div> ); ;

    case "ACCEPTED":
      return ( <div className="nex-pill accepted">Accepted</div> ); 

    case "OFFERED":
      return ( <div className="nex-pill offered">Offered</div> ); 

    case "HIRED":
      return ( <div className="nex-pill hired">Hired</div> ); 

    case "CLOSED":
      return ( <div className="nex-pill closed">Closed</div> ); 

    case "ON_HOLD":
      return ( <div className="nex-pill on-hold">On-Hold</div> ); 

    case "DRAFT":
      return ( <div className="nex-pill draft">Draft</div> ); 
    case "PUBLISHED":
      return ( <div className="nex-pill published">Published</div> ); 

    case "SUBMITTED":
      return ( <div className="nex-pill submitted">Submitted</div> ); 

    case "REJECTED":
      return ( <div className="nex-pill rejected">Rejected</div> ); 

    case "CANCELED":      
      return ( <div className="nex-pill cancelled">Canceled</div> ); 

    default:
      return ( <div className="nex-pill in-review">{convertJobShiftToTitleCase(status)}</div> ); 
  }
};

export default ShowStatus;